/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var receivablesFeeTaxesColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Несъбр. падеж. такси',
  render: function render(_ref) {
    var total_late_fees = _ref.total_late_fees,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees"
    }, total_late_fees, " ", currency);
  }
}, {
  name: 'Несъбр. падеж. лихви',
  render: function render(_ref2) {
    var total_late_interests = _ref2.total_late_interests,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests"
    }, total_late_interests, " ", currency);
  }
}, {
  name: 'Общо несъбр. падеж.',
  render: function render(_ref3) {
    var total_late = _ref3.total_late,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late"
    }, total_late, " ", currency);
  }
}, {
  name: 'Бъдещи такси',
  render: function render(_ref4) {
    var total_future_fees = _ref4.total_future_fees,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_fees"
    }, total_future_fees, " ", currency);
  }
}, {
  name: 'Бъдещи лихви',
  render: function render(_ref5) {
    var total_future_interests = _ref5.total_future_interests,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_interests"
    }, total_future_interests, " ", currency);
  }
}, {
  name: 'Общо бъдещи',
  render: function render(_ref6) {
    var total_future = _ref6.total_future,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future"
    }, total_future, " ", currency);
  }
}];